var _FavoriteServiceInit_instances, _FavoriteServiceInit_favorites, _FavoriteServiceInit_storage, _FavoriteServiceInit_loadFavorites, _FavoriteServiceInit_saveFavorites;
import { __classPrivateFieldGet } from "tslib";
import { get, writable } from 'svelte/store';
import { LocalStorageManager } from '../model/storage/LocalStorageManager';
class FavoriteServiceInit {
    constructor() {
        _FavoriteServiceInit_instances.add(this);
        _FavoriteServiceInit_favorites.set(this, writable([]));
        _FavoriteServiceInit_storage.set(this, new LocalStorageManager());
        __classPrivateFieldGet(this, _FavoriteServiceInit_instances, "m", _FavoriteServiceInit_loadFavorites).call(this);
    }
    get favorites() {
        return __classPrivateFieldGet(this, _FavoriteServiceInit_favorites, "f");
    }
    isFavorite(platform, keyId) {
        const favorites = get(__classPrivateFieldGet(this, _FavoriteServiceInit_favorites, "f"));
        return favorites.some((it) => it.platform === platform && it.keyId === keyId);
    }
    addFavorite(platform, keyId) {
        if (this.isFavorite(platform, keyId)) {
            console.warn('duplicated favorite');
            return;
        }
        const favorite = { platform, keyId };
        __classPrivateFieldGet(this, _FavoriteServiceInit_favorites, "f").update((it) => [...it, favorite]);
        __classPrivateFieldGet(this, _FavoriteServiceInit_instances, "m", _FavoriteServiceInit_saveFavorites).call(this);
    }
    removeFavorite(platform, keyId) {
        __classPrivateFieldGet(this, _FavoriteServiceInit_favorites, "f").update((it) => it.filter((f) => f.platform !== platform || f.keyId !== keyId));
        __classPrivateFieldGet(this, _FavoriteServiceInit_instances, "m", _FavoriteServiceInit_saveFavorites).call(this);
    }
}
_FavoriteServiceInit_favorites = new WeakMap(), _FavoriteServiceInit_storage = new WeakMap(), _FavoriteServiceInit_instances = new WeakSet(), _FavoriteServiceInit_loadFavorites = function _FavoriteServiceInit_loadFavorites() {
    const rawFavorites = __classPrivateFieldGet(this, _FavoriteServiceInit_storage, "f").favoriteStreams;
    const favorites = JSON.parse(rawFavorites);
    __classPrivateFieldGet(this, _FavoriteServiceInit_favorites, "f").set(favorites);
}, _FavoriteServiceInit_saveFavorites = function _FavoriteServiceInit_saveFavorites() {
    const favorites = get(__classPrivateFieldGet(this, _FavoriteServiceInit_favorites, "f"));
    const rawFavorites = JSON.stringify(favorites);
    __classPrivateFieldGet(this, _FavoriteServiceInit_storage, "f").favoriteStreams = rawFavorites;
};
export const FavoriteService = new FavoriteServiceInit();
